import type { AxiosResponse } from "axios";
import type { InferType } from "yup";
import * as yup from "yup";

import api from "../utils/AxiosInterceptor";
import i18n from "../i18n";

export const forgotPasswordSchemaInput = yup.object({
  cpf: yup.string().required(() => i18n.t("validation.cpfRequired")).validateCpf(),
});

export type ForgotPasswordInput = InferType<typeof forgotPasswordSchemaInput>;

export interface UserResponse {
  id: number;
  email: string;
  name: string;
}

export async function requestNewPassword(
  input: ForgotPasswordInput,
): Promise<AxiosResponse<UserResponse>> {
  const response = await api.post(`/api/v1/auth/recover-password/${input.cpf}`);
  return response;
}

export const updatePasswordSchemaInput = yup.object({
  password: yup.string().validatePassword(),
  confirmPassword: yup
    .string()
    .oneOf(
      [yup.ref("password"), undefined],
      () => i18n.t("validation.passwordsMustMatch"),
    ),
  id: yup.string(),
});

export type UpdatePasswordInput = InferType<typeof updatePasswordSchemaInput>;

export async function updateNewPassword(
  input: UpdatePasswordInput,
): Promise<void> {
  await api.post(`/api/v1/auth/recover-password`, input);
}
